"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useRecommendationStepper = require("../../hooks/recommendation/useRecommendationStepper");
var _constants = require("../../utils/constants");
var _RecommendationTabs = _interopRequireDefault(require("./RecommendationTabs"));
var _UpsellSubPage = _interopRequireDefault(require("./UpsellSubPage"));
var _RecommendationBroadband = _interopRequireDefault(require("./RecommendationBroadband/RecommendationBroadband"));
var _DynamicRecommendationPlans = _interopRequireDefault(require("./RecommendationAirtimePlans/DynamicRecommendationPlans"));
var _DynamicRecommendationBusinessSolutions = _interopRequireDefault(require("./RecommendationBusinessSolution/Entel/DynamicRecommendationBusinessSolutions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RecommendationBodyFactory = props => {
  const {
    currentStepObject
  } = (0, _useRecommendationStepper.useRecommendationStepper)();
  const stepType = currentStepObject === null || currentStepObject === void 0 ? void 0 : currentStepObject.stepType;
  switch (stepType) {
    case _constants.STEP_TYPES.HANDSET:
      return /*#__PURE__*/_react.default.createElement(_RecommendationTabs.default, props);
    case _constants.STEP_TYPES.AIRTIME_PLAN:
      return /*#__PURE__*/_react.default.createElement(_DynamicRecommendationPlans.default, props);
    case _constants.STEP_TYPES.UPSELL:
      return /*#__PURE__*/_react.default.createElement(_UpsellSubPage.default, props);
    case _constants.STEP_TYPES.BROADBAND:
      return /*#__PURE__*/_react.default.createElement(_RecommendationBroadband.default, props);
    case _constants.STEP_TYPES.BUSINESS_SOLUTION:
      return /*#__PURE__*/_react.default.createElement(_DynamicRecommendationBusinessSolutions.default, props);
    default:
      return /*#__PURE__*/_react.default.createElement(_RecommendationTabs.default, props);
  }
};
var _default = RecommendationBodyFactory;
exports.default = _default;